module.exports = __webpack_public_path__ + "img/YouTube Icon.4e8b1836.svg";